import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stringArrayToDisplayValue',
    standalone: false
})
export class StringArrayToDisplayValue implements PipeTransform {
      transform(value: string[]): string {
        if (value && value.length > 0) {
          return value.join(', ');
    }
    return '';
  }
}